import { styled } from '@linaria/react';

export const Container = styled.div`
	--padding-container: var( --size-2md );

	width: 100%;
	height: 100%;
	max-width: ${ ( props ) =>
		props.isWide ? 'var( --wide-size )' : 'var( --content-size )' };
	padding-inline: var( --padding-container );
	margin-inline: auto;
`;

export const Row = styled.div`
	display: flex;
	flex-direction: ${ ( props ) => props.direction || 'row' };
	gap: ${ ( props ) => props.gap || '1rem' };

	@media ( max-width: 768px ) {
		flex-direction: ${ ( props ) => props.mobileDirection || 'column' };
	}
`;

export const Col = styled.div`
	flex: ${ ( props ) => props.size || '1' };
`;
